// extracted by mini-css-extract-plugin
export default {"root":"unstyled-button_root__v-bpV"};